import { get } from 'lodash/fp';
import { createElement } from 'react';
import { connect } from 'react-redux';
import ApiError from '../../ApiError';
import ApiWarning from '../../ApiWarning';
import Modal from '../../Modal';
import { SPECIFIC_EXCEPTION_COMPONENTS } from '../RegisteredExceptions';
import { actionCreators, selectors } from './ducks';

const ApiExceptionInline = ({ error, stateKey = undefined }) => {
    if (!error) {
        return null;
    }

    const message = get('response.data.message')(error);

    const specificErrorComponent = SPECIFIC_EXCEPTION_COMPONENTS[stateKey];
    const hasSpecificErrorComponent = !!specificErrorComponent && !!specificErrorComponent[message];

    return hasSpecificErrorComponent ? (
        <ApiWarning>{createElement(SPECIFIC_EXCEPTION_COMPONENTS[stateKey][message], {})}</ApiWarning>
    ) : (
        <ApiError error={error} />
    );
};

const ApiExceptionModalP = ({ stateKey, error, onErrorReset }) => (
    <Modal isOpen={!!error} onClose={onErrorReset} size="MD_WIDTH">
        <ApiExceptionInline error={error} stateKey={stateKey} />
    </Modal>
);

const mapStateToProps = (state, { stateKey }) => ({
    error: selectors.getException(state, stateKey),
    stateKey,
});

const mapDispatchToProps = (dispatch, { stateKey }) => ({
    onErrorReset: () => dispatch(actionCreators.doErrorReset(stateKey)),
});

const ApiExceptionModal = connect(mapStateToProps, mapDispatchToProps)(ApiExceptionModalP);

export { ApiExceptionInline, ApiExceptionModal };
